import React from 'react';
import LoginScreen from '@/components/auth/LoginScreen';

const ADMIN_BG = 'https://images.unsplash.com/photo-1596339273187-8b3c69879f5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxhbHBpbmUlMjBsYWtlJTIwcGluZSUyMGZvcmVzdCUyMG1pc3QlMjBiYW5uZXJ8ZW58MHx8fHRlYWx8MTc4NDc5NDU2Nnww&ixlib=rb-4.1.0&q=85';

export default function AdminLogin() {
  return (
    <LoginScreen
      bg={ADMIN_BG}
      badge="Amministrazione"
      heroTitle="Sila Experiences"
      heroText="Pannello di amministrazione. Gestione centralizzata del CRM, contenuti e stakeholder."
      formTitle="Accesso amministratore"
      formSubtitle="Area riservata allo staff amministrativo."
      showOAuth={false}
      testidPrefix="admin-login"
    />
  );
}
